/* eslint-disable max-len */
import React from 'react';
import env from '../config/variables';

const { FB_PIXEL_ID } = env;

const pixelScript = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;t.onload=function(){document.dispatchEvent(new Event('fbLoaded'));};s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', ${ FB_PIXEL_ID });fbq('track', 'PageView');`;
const pixelNoscript = `
<img
  alt=""
  height="1"
  width="1"
  style={ { display: 'none' } }
  src="https://www.facebook.com/tr?id=${ FB_PIXEL_ID }&ev=PageView&noscript=1"
/>`;

export const facebookPixelScript = () => {
  if (!FB_PIXEL_ID) return null;
  return (
    <script
      async
    >
      {pixelScript}
    </script>
  );
};

export const facebookPixelNoscript = () => {
  const noscript = document.createElement('noscript');
  noscript.id = 'facebook_pixel_noscript';
  noscript.innerHTML = pixelNoscript;
  return noscript;
};
